<div class="mb-27 mct-flex mct-row mct-justify-between mct-items-center">
  <span class="title-header">{{ 'public-links.title' | translate | titlecase }}</span>
  <button pButton type="button" *ngIf="showUpgradeButton" class="mct-flex atlas-btn atlas-btn-primary mct-justify-center mct-items-center"
    type="button" (click)="openUpgradeDialog()">
    <span>{{ 'public-links.upgrade-all-pages' | translate | uppercase }}</span>
  </button>
</div>

<div class="card-container">
  <div class="mct-flex mct-col mct-gap-10" [hidden]="!showDomains">
    <label for="batch" class="card-field-label">
      {{ 'public-links.website-domain' | translate | titlecase }}
    </label>
    <p-select name="batch" appendTo="body" [options]="domainSettingBatches"
      [style]="{ 'min-width': '270px', 'max-width': '350px' }" [placeholder]="'common.select-one' | translate"
      [(ngModel)]="selectedSettingBatch" (onChange)="getWebComponentSettings()"></p-select>
  </div>

  <div [hidden]="hideTable" class="atlas-table mt-27">
    <p-table [showGridlines]="true" [value]="publicLinks">
      <ng-template pTemplate="sorticon" field="col.field" let-sortOrder>
        <SortAltIcon *ngIf="sortOrder === 0">
          <span><i class="p-sortable-column-icon pi pi-fw pi-sort-alt" aria-hidden="true"></i></span>
        </SortAltIcon>
        <SortAmountUpAltIcon *ngIf="sortOrder === 1" [styleClass]="'p-sortable-column-icon'">
          <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-up-alt" aria-hidden="true"></i></span>
        </SortAmountUpAltIcon>
        <SortAmountDownIcon *ngIf="sortOrder === -1" [styleClass]="'p-sortable-column-icon'">
          <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-down" aria-hidden="true"></i></span>
        </SortAmountDownIcon>
      </ng-template>
      <ng-template pTemplate="header">
        <tr>
          <th pSortableColumn="Name">
            {{ 'public-links.page' | translate | ucfirst }}
            <p-sortIcon field="Name"></p-sortIcon>
          </th>
          <th pSortableColumn="Latest">
            {{ 'public-links.version' | translate | ucfirst }}
            <p-sortIcon field="Latest"></p-sortIcon>
          </th>
          <th pSortableColumn="Url">
            {{ 'public-links.url' | translate | ucfirst }}
            <p-sortIcon field="Url"></p-sortIcon>
          </th>
          <th [style]="{ width: '120px' }"></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-link>
        <tr>

          <td>{{ link.Name }}</td>
          <td *ngIf="link.Latest; else legacyText" class="green">
            {{ 'public-links.latest' | translate | ucfirst }}</td>
          <td>
            <a [href]="link.Url" target="_blank"> {{ link.Url }}</a>
          </td>
          <td class="t-al">
            <wl-ephemeral-content-swap #contentSwap>
              <button pButton type="button" class="atlas-btn atlas-btn-primary" ngxClipboard [cbContent]="link.Url"
                (click)="contentSwap.show()">
                {{ 'public-links.copy-url' | translate | uppercase }}
              </button>
              <div class="wl-ephemeral-content">
                {{ 'common.copied-to-clipboard' | translate | ucfirst }}
              </div>
            </wl-ephemeral-content-swap>
          </td>
        </tr>
      </ng-template>
    </p-table>
    <p-progressSpinner *ngIf="loading"></p-progressSpinner>
  </div>
</div>

<ng-template #legacyText>
  <td class="red">
    {{ 'public-links.legacy' | translate | ucfirst }}
  </td>
</ng-template>

<wl-public-links-upgrade-dialog #upgradeDialog
  (onUpdateSettings)="updateSettings($event)"></wl-public-links-upgrade-dialog>
<wl-public-links-progress-dialog #progressDialog></wl-public-links-progress-dialog>
